import React, { Component } from 'react'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import { Col, Row } from 'react-bootstrap'
import { Heading, ContainerBox } from './AdminStyle';
import { LogeButtonSlim } from '../GeneralStyle'
import ConfirmSendNewContractsModal from "../internal/Modals/ConfirmSendNewContractsModal"
import ConfirmSendNewInvoicesModal from "../internal/Modals/ConfirmSendNewInvoicesModal"
import ApplicationTable from '../Tables/ApplicationTable';
import styled from 'styled-components'
import { DoubleBounce } from 'better-react-spinkit'
import Parse from 'parse'

import Editor, { createEditorStateWithText } from 'draft-js-plugins-editor';
import { EditorState, convertToRaw, convertFromRaw, convertFromHTML } from 'draft-js';
import createLinkPlugin from 'draft-js-anchor-plugin';
import createInlineToolbarPlugin from 'draft-js-inline-toolbar-plugin';
import { ItalicButton, BoldButton, UnderlineButton, HeadlineTwoButton } from 'draft-js-buttons';
import { stateToHTML } from 'draft-js-export-html';
import { stateFromHTML } from 'draft-js-import-html';

import config from 'react-global-configuration';
import 'draft-js-inline-toolbar-plugin/lib/plugin.css';

import { EditorInput } from '../internal/BlackboardBlog/BlackboardStyle'

const linkPlugin = createLinkPlugin();
const inlineToolbarPlugin = createInlineToolbarPlugin({
  structure: [
    HeadlineTwoButton,
    BoldButton,
    ItalicButton,
    UnderlineButton,
    linkPlugin.LinkButton
  ]
});
const { InlineToolbar } = inlineToolbarPlugin;
const plugins = [inlineToolbarPlugin, linkPlugin];

const text = 'Regeln';



@inject('userStore')

@observer
class Dashboard extends Component {

  constructor(props) {
    super(props)
    this.state = {
      editorState: undefined,
      blogHTML: "",
      isLoading: true,
      saveState: 0 // 0: normal, 1: loading, 3: error, 2: success
    }

    Parse.Config.get().then(async config => {
      let rules = await config.get("RULES")
      this.setState({ editorState: EditorState.createWithContent(stateFromHTML(rules)) })
    }).catch(err => console.error(err))

  }

  componentWillMount() {
  }

  save = async () => {

    this.setState({saveState: 1})

    const { blogHTML } = this.state

    if(!blogHTML)
      return

    await Parse.Cloud.run('updateRules', { html: blogHTML })
    .catch(err => this.setState({saveState: 3}))

    this.setState({saveState: 2})

    setTimeout(() => {
      this.setState({saveState: 0})
    }, 2000);

  }

  onEditorChange = (editorState) => {
    this.setState({
      editorState: editorState,
      blogHTML: stateToHTML(editorState.getCurrentContent())

    });
  };

  render() {
    const { isAdmin, isLoge } = this.props.userStore;

    if (!isAdmin) {
      //this.props.history.push("/")
    }

    return (
      <div>
      {(isAdmin || isLoge) ?
          <div>
            <Row style={{maxWidth: 1200, margin: "0 auto"}}>
              <Col xs={12} md={12} lg={12} className={'mobile-no-padding'} >
                <ContainerBox style={{paddingBottom: 25}}>
                  <Row style={{maxWidth: 1200, margin: "0 auto"}}>
                    <Col md={12}>
                      <Heading style={{display: "inline-block"}}>Regelwerk bearbeiten</Heading>
                      { this.state.editorState &&
                        <LogeButtonSlim
                          hoverFontColor={"white"}
                          onClick={this.save}
                          disabled={this.state.saveState === 1}
                          style={{float: "right", marginRight: 15}}
                        >
                          {this.state.saveState === 1 ? "Loading..." : this.state.saveState === 2 ? "Gespeichert" : this.state.saveState === 3 ? "Fehler" : "Speichern"}
                        </LogeButtonSlim>
                      }
                      <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>
                    </Col>
                    <Col md={12} style={{ padding: "30px 30px"}}>
                      { this.state.editorState ?
                        <EditorInput
                          onClick={this.focus}>
                          <Editor
                            editorState={this.state.editorState}
                            onChange ={this.onEditorChange}
                            plugins={plugins}
                            ref={(element) => { this.editor = element; }}
                          />
                          <InlineToolbar />
                        </EditorInput>
                      :
                      <DoubleBounce color={"#DAB777"} size={60}/>
                      }
                    </Col>

                    <Col md={12} style={{paddingLeft: 25, textAlign: "center"}}>
                      { this.state.editorState &&
                        <LogeButtonSlim
                          hoverFontColor={"white"}
                          onClick={this.save}
                          disabled={this.state.saveState === 1}
                        >
                          {this.state.saveState === 1 ? "Loading..." : this.state.saveState === 2 ? "Gespeichert" : this.state.saveState === 3 ? "Fehler" : "Speichern"}
                        </LogeButtonSlim>
                      }
                    </Col>
                  </Row>

                </ContainerBox>
              </Col>
            </Row>
          </div>
          : ''}

      </div>
    )
  }
}

export default Dashboard



// WEBPACK FOOTER //
// /src/components/admin/EditRules.js